module.exports = __webpack_public_path__ + "img/svg/step7.41f78ef63996deb46d08af9a5a0375e5.svg";